import Vue from 'Vue';
import { SearchService } from '@/services/rtps/search.service';
import { MetricsService } from '@/services/rtps/metrics.service';
import * as FileDownload from 'js-file-download';
import { ERROR_HANDLE_ERROR } from '../error/actions.type';

import {
  RTPS_HISTORY_SEARCH,
  RTPS_HISTORY_EXPORT,
  RTPS_METRICS,
  RTPS_STATISTICS
} from './rtps.actions';

import {
  SET_RTPS_SEARCH_COMPLETE,
  SET_RTPS_SEARCH_BUSY,
  SET_RTPS_EXPORT_BUSY,
  SAVE_RTPS_EXPORT_FIELDS,
  SET_RTPS_METRICS
} from './rtps.mutations';

const initialState = {
  searchCriteria: {},
  searchResults: null,
  isSearchBusy: false,
  isExportBusy: false,
  savedExportFields: [],
  metrics: { PatientSavingsTimeSeries: null, PatientSavingsSingleValue: null, RxDispositionTimeSeries: null, RxDispositionSingleValue: null }
};

export const state = Object.assign({}, initialState);

export const actions = {
  [RTPS_HISTORY_SEARCH](context, criteria) {
    context.commit(SET_RTPS_SEARCH_BUSY, true);
    return SearchService.query(criteria).then(({ data }) => {
      context.commit(SET_RTPS_SEARCH_BUSY, false);
      if (data.errorMessage) {
        context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
      } else {
        context.commit(SET_RTPS_SEARCH_COMPLETE, data);
      }
      return data;
    },
      (err) => { context.dispatch(ERROR_HANDLE_ERROR, err); }
    );
  },
  [RTPS_HISTORY_EXPORT](context, criteria) {
    context.commit(SET_RTPS_EXPORT_BUSY, true);
    return SearchService.export(criteria)
      .then(({ data }) => {
        context.commit(SET_RTPS_EXPORT_BUSY, false);
        if (data.errorMessage) {
          context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
        } else {
          FileDownload(data, 'RTPSExport.csv');
        }
        return data;
      },
        (err) => {
          context.dispatch(ERROR_HANDLE_ERROR, err);
        });
  },
  [RTPS_METRICS](context, criteria) {
    return MetricsService.getMetrics(criteria)
      .then(({ data }) => {
        if (data.errorMessage) {
          context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
        } else {
          context.commit(SET_RTPS_METRICS, { view: criteria.view, data: data });
        }
        return data;
      },
        (err) => {
          context.dispatch(ERROR_HANDLE_ERROR, err);
        });
  },
  [RTPS_STATISTICS](context, criteria) {
    return MetricsService.getStatistics(criteria)
      .then(({ data }) => {
        if (data.errorMessage) {
          context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
        } else {
          context.commit(SET_RTPS_METRICS, { view: criteria.view, data: data });
        }
        return data;
      },
        (err) => {
          context.dispatch(ERROR_HANDLE_ERROR, err);
        });
  }
};

export const mutations = {
  [SET_RTPS_SEARCH_COMPLETE](state, results) {
    state.searchResults = results;
  },
  [SET_RTPS_EXPORT_BUSY](state, isBusy) {
    state.isExportBusy = isBusy;
  },
  [SET_RTPS_SEARCH_BUSY](state, isBusy) {
    state.isSearchBusy = isBusy;
  },
  [SAVE_RTPS_EXPORT_FIELDS](state, fields) {
    state.savedExportFields = fields;
  },
  [SET_RTPS_METRICS](state, metrics) {
    Vue.set(state.metrics, metrics.view, metrics.data);
  }
};

export const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/rtps/rtps.module.js